import { CALL_API } from './../../middlewares/api';
import moment from 'moment';

const onLoadListaMudancasIfNeeded = () => ({
  [CALL_API]: {
    type: 'LIST_MUDANCAS',
    endpoint: 'mudancas',
    authenticated: true,
    config: {
      method: 'GET'
    }
  }
});

const onLoadListaMudancas = () => (dispatch, getState) => {
  let { fetching, errors } = getState().mudancas;

  if (!fetching && !errors.length) {
    dispatch(onLoadListaMudancasIfNeeded());
  }
};

const onLoadDetalheMudancaIfNeeded = value => ({
  [CALL_API]: {
    type: 'LIST_MUDANCAS_DETALHE',
    endpoint: 'mudancas',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'detalhe', id: value.id }
    }
  },
  value
});

const onLoadDetalheMudanca = value => dispatch => {
  let { fetching, errors = [] } = value.detail || {};
  if (!fetching && !errors.length) {
    return dispatch(onLoadDetalheMudancaIfNeeded(value));
  }
  return Promise.resolve(value);

};

const adicionaMudanca = value => ({
  [CALL_API]: {
    type: 'ADD_MUDANCAS',
    endpoint: 'mudancas',
    authenticated: true,
    config: {
      method: 'POST',
      querystring: { type: 'add' },
      body: {
        ...value,
        ...(timezone => ({
          timezone,
          data_mudanca: moment(value.data_mudanca).utcOffset(timezone, true).format()
        }))(moment().format('Z'))
      }
    }
  },
  value
});

const cancelaMudanca = value => ({
  [CALL_API]: {
    type: 'CANCEL_MUDANCAS',
    endpoint: 'mudancas',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: { type: 'cancel', id: value.id },
      body: {
        unidade: value.unidade
      }
    }
  },
  value
});

export default {
  onLoadListaMudancas,
  onLoadListaMudancasIfNeeded,
  onLoadDetalheMudanca,
  adicionaMudanca,
  cancelaMudanca
};


// WEBPACK FOOTER //
// ./src/modules/mudancas/actions.js